import './BackToClinicDashboard.css';
import { useNavigate } from 'react-router-dom';

const BackToClinicDashboard = () => {
  const navigate = useNavigate();

  return (
    <button
      className="back-to-clinic-button"
      onClick={() => navigate('/admin/clinic-dashboard')}
    >
      ← Back to Clinic Dashboard
    </button>
  );
};

export default BackToClinicDashboard;